import { requestApi } from './Api';

export const createFormPacket = (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/practice/settings/forms/form_packet/upsert'
  });

export const updateFormPacket = (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/practice/settings/forms/form_packet/update'
  });

export const getFormPacketsSelected = (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/practice/settings/forms/form_packet/selected'
  });
